import { useGetApiTokensRoles } from '@ipfabric/api-client/client/model/api-token/api-token';
import type { SelectOptionType } from 'components/Select/SelectOption';
import { useMemo } from 'react';

export const useApiTokenRolesOptions = ():
  | SelectOptionType<string>[]
  | null => {
  const rolesQuery = useGetApiTokensRoles();

  return useMemo(
    () =>
      rolesQuery.data?.map((role) => ({
        value: role.id,
        label: role.name,
      })) ?? null,
    [rolesQuery.data],
  );
};
